import React from 'react';
import SurveyItem from '../../util/SurveyItem';
import { defineMessages, useIntl } from 'react-intl';
import Attachment from './Attachment';
import imageCompression from 'browser-image-compression';

const messages = defineMessages({
  addPhoto: {
    id: 'surveyItem.photo.add',
    defaultMessage: 'Photo or PDF',
  },
});

export interface PhotoOwnProps {
  surveyItem: SurveyItem;
}

const Photo = (props: PhotoOwnProps) => {
  const { surveyItem } = props;
  const { formatMessage } = useIntl();

  const fileProcessor = async (file: File) => {
    if (file.type === 'application/pdf') return file;

    return imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
    });
  };

  return (
    <Attachment
      surveyItem={surveyItem}
      allowedExtensions=".jpg,.jpeg,.png,.pdf"
      shouldShowFilePreview={true}
      attachButtonTitle={formatMessage(messages.addPhoto)}
      fileProcessor={fileProcessor}
    />
  );
};

export default Photo;
